import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Title text="Projects" mdxType="Title" />
    <p><a parentName="p" {...{
        "href": "https://github.com/dboston528/artist-booking"
      }}>{`Fyyur Artist Booking`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/dboston528/notes-app"
      }}>{`CLI Note Taking App`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/dboston528/My-Reads"
      }}>{`My Reads`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/dboston528/cost-time-calculator"
      }}>{`Cost Time Calculator`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      